import { useMemo } from 'react'
import queryString from 'query-string'
import { useRouterContext } from '../shared/contexts/router.context'

const useGetParamsQuery = () => {
  const { location } = useRouterContext()
  return useMemo(
    () => queryString.parse(__BROWSER__ ? location.search : ''),
    [location.search],
  )
}

export default useGetParamsQuery
